/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */

export type InvoicesListStatusItem = typeof InvoicesListStatusItem[keyof typeof InvoicesListStatusItem];


export const InvoicesListStatusItem = {
  approved: 'approved',
  'partial-approval': 'partial-approval',
  pending: 'pending',
  'pending-data': 'pending-data',
  rejected: 'rejected',
  reset: 'reset',
} as const;
